import { useCallback } from 'react';
import { useMutation, gql } from '@apollo/react-hooks';
import { get, pick } from 'lodash';
import type { UpdateManufacturerMutation, Manufacturer } from '#/graphql/types';
import { updateManufacturer } from '#/graphql/mutations';
import { updateMutationFields } from '../utils/mutationDataFields';
import { GET_MANUFACTURER } from './useManufacturerQuery';

const q = gql(updateManufacturer);

const useManufacturerUpdate = () => {
  const [mutation, result] = useMutation<UpdateManufacturerMutation>(q);
  const updateManufacturer = useCallback(
    async (itemId: string, manufacturer: Manufacturer) => {
      const response = await mutation({
        variables: {
          id: itemId,
          data: pick(manufacturer, updateMutationFields),
        },
        refetchQueries: [{ query: GET_MANUFACTURER, variables: { id: itemId } }],
        awaitRefetchQueries: true,
      });

      return get(response, 'data.updateManufacturer', undefined);
    },
    [mutation],
  );

  return { updateManufacturer, result };
};

export default useManufacturerUpdate;
